/**
 * PinSidebarButton
 */

import React from 'react';
import classnames from 'classnames';
import { Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import throttle from 'lodash.throttle';

// Actions
import {
    pinSidebar,
    unpinSidebar
} from '../../../../../../services/ui/actions';

// Selectors
import { selectPinnedSidebar } from '../../../../../../services/ui/selectors';

// Styles
import './styles.scss';

interface Props {
    pinned: boolean;
    pinSidebar: Function;
    unpinSidebar: Function;
}

interface State {
    isMobile: boolean;
}

class PinSidebarButton extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { isMobile: false };
        this.handleWindowResize = throttle(this.handleWindowResize, 300);
    }

    componentDidMount() {
        this.handleWindowResize();
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize = () => {
        this.setState({
            isMobile: window.innerWidth < 1024
        });
    };

    handleClick = () => {
        const { pinned } = this.props;
        pinned ? this.props.unpinSidebar() : this.props.pinSidebar();
    };

    render() {
        const { pinned } = this.props;
        const { isMobile } = this.state;
        if (pinned && isMobile) {
            this.props.unpinSidebar();
        }
        const classes = classnames('pin-sidebar-button', { active: pinned });
        return (
            <div className="pin-sidebar-button-container">
                <button
                    onClick={this.handleClick}
                    className={classes}
                    type="button"
                >
                    <Icon name="pin" />
                </button>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    pinned: selectPinnedSidebar
});

export default connect(
    mapStateToProps,
    { pinSidebar, unpinSidebar }
)(PinSidebarButton);
